import { type FC, type ComponentProps, type ReactNode } from "react";
import { BenefitIcon } from "../BenefitIcon/BenefitIcon";

import styles from "./ProBenefits.module.scss";
import { FormattedHTMLMessage } from "~/nvent-web/components/FormattedHTMLMessage/FormattedHTMLMessage";

export const ProBenefits: FC = () => {
  return (
    <section className={styles.container}>
      <ul className={styles.benefits}>
        {benefits.map((benefit, index) => (
          <li className={styles.card} key={index}>
            <BenefitIcon icon={benefit.icon} />
            <div className={styles.description}>{benefit.description}</div>
          </li>
        ))}
      </ul>
    </section>
  );
};

const benefits: Array<{
  icon: ComponentProps<typeof BenefitIcon>["icon"];
  description: ReactNode;
}> = [
  {
    icon: "Certificate",
    description: (
      <FormattedHTMLMessage
        id="certifiedPage.proBenefits.accredited"
        Element="p"
      />
    ),
  },
  {
    icon: "TwentyYears",
    description: (
      <FormattedHTMLMessage id="certifiedPage.proBenefits.rights" Element="p" />
    ),
  },
  {
    icon: "Website",
    description: (
      <FormattedHTMLMessage
        id="certifiedPage.proBenefits.referrals"
        Element="p"
        values={{
          url: "https://www.chemelex.com/raychem/solutions/commercial/floor-heating",
        }}
      />
    ),
  },
  {
    icon: "Promotions",
    description: (
      <FormattedHTMLMessage
        id="certifiedPage.proBenefits.promotions"
        Element="p"
      />
    ),
  },
  {
    icon: "Events",
    description: (
      <FormattedHTMLMessage id="certifiedPage.proBenefits.events" Element="p" />
    ),
  },
];
